import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { GenericModule } from '../generic/index';
import { SpinnerModule } from '../spinner/index';

import { LoadingComponent } from './loading.component';

export { LoadingComponent } from './loading.component';

@NgModule({
  declarations: [
    LoadingComponent
  ],
  imports: [
    GenericModule,
    SpinnerModule
  ],
  exports: [
    LoadingComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class LoadingModule {}
